import script from "./MiNTNewsDetailSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MiNTNewsDetailSection.vue?vue&type=script&setup=true&lang=js"

import "./MiNTNewsDetailSection.vue?vue&type=style&index=0&id=9af96e46&lang=css"
import "./MiNTNewsDetailSection.vue?vue&type=style&index=1&id=9af96e46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9af96e46"]])

export default __exports__